import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      sessionStorage.setItem("ai_token", data.token);
      toast.success("Benvenuto in atelier.");
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-[#080808] px-4">
      <div className="w-full max-w-sm border border-[#262420] bg-[#0F0F0E] p-8 sm:p-10">
        <p className="font-serif text-2xl text-[#F3EFE6]">
          Arte <span className="italic text-[#C8A86B]">&</span> Infissi
        </p>
        <p className="mt-2 text-xs font-mono uppercase tracking-[0.25em] text-[#827D72]">Area Riservata</p>

        <form onSubmit={submit} className="mt-8 flex flex-col gap-5">
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="admin-email" className="text-xs font-mono uppercase tracking-wider text-[#827D72]">Email</Label>
            <Input
              id="admin-email"
              data-testid="admin-login-email"
              type="email"
              required
              autoComplete="username"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="border-[#262420] bg-[#080808] text-[#F3EFE6] focus-visible:ring-[#C8A86B]"
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="admin-password" className="text-xs font-mono uppercase tracking-wider text-[#827D72]">Password</Label>
            <Input
              id="admin-password"
              data-testid="admin-login-password"
              type="password"
              required
              autoComplete="current-password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="border-[#262420] bg-[#080808] text-[#F3EFE6] focus-visible:ring-[#C8A86B]"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="border border-[#C25D53]/40 bg-[#C25D53]/10 px-3 py-2 text-xs text-[#C25D53]">{error}</p>
          )}
          <button
            type="submit"
            data-testid="admin-login-button"
            disabled={loading}
            className="mt-2 bg-[#C8A86B] px-6 py-3 text-sm uppercase tracking-[0.15em] text-[#080808] transition-colors duration-300 hover:bg-[#D8BD85] disabled:opacity-50"
          >
            {loading ? "…" : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
